import { render, staticRenderFns } from "./ResumoAlertas.vue?vue&type=template&id=d6bb5a46&scoped=true&"
import script from "./ResumoAlertas.vue?vue&type=script&lang=js&"
export * from "./ResumoAlertas.vue?vue&type=script&lang=js&"
import style0 from "./ResumoAlertas.vue?vue&type=style&index=0&id=d6bb5a46&scoped=true&lang=css&"
import style1 from "./ResumoAlertas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bb5a46",
  null
  
)

export default component.exports